import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, KeyRound } from "lucide-react";
import { api, formatApiError } from "@/auth";

const inputCls =
  "w-full rounded-lg border border-white/10 bg-white/5 px-4 py-3 text-sm text-white placeholder-zinc-500 outline-none transition-colors duration-300 focus:border-accent";
const labelCls = "mb-2 block font-mono text-[11px] font-bold uppercase tracking-[0.2em] text-zinc-400";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [pwd, setPwd] = useState({ password: "", confirm: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pwd.password !== pwd.confirm) {
      toast.error("Las contraseñas no coinciden.");
      return;
    }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pwd.password });
      toast.success("Contraseña actualizada. Ya puedes entrar con la nueva.");
      navigate("/acceso");
    } catch (err) {
      toast.error(formatApiError(err));
      setBusy(false);
    }
  };

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden px-5 pb-16 pt-28">
      <p className="pointer-events-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 select-none font-display text-[26vw] font-black uppercase leading-none text-white/[0.03]">
        K-HOUSE
      </p>
      <div className="relative w-full max-w-md">
        <div className="mb-8 text-center">
          <h1 className="font-display text-3xl font-extrabold uppercase tracking-tight">Nueva contraseña</h1>
          <p className="mt-2 text-sm text-zinc-400">Elige una contraseña nueva para tu cuenta de K-house.</p>
        </div>
        <form
          data-testid="reset-form"
          onSubmit={submit}
          className="space-y-5 rounded-2xl border border-white/10 bg-panel p-6 shadow-[0_0_40px_rgba(255,0,122,0.12)] sm:p-8"
        >
          <div>
            <label htmlFor="reset-password" className={labelCls}>Nueva contraseña *</label>
            <input
              id="reset-password"
              data-testid="reset-input-password"
              type="password"
              required
              minLength={6}
              value={pwd.password}
              onChange={(e) => setPwd((p) => ({ ...p, password: e.target.value }))}
              className={inputCls}
            />
          </div>
          <div>
            <label htmlFor="reset-confirm" className={labelCls}>Repite la contraseña *</label>
            <input
              id="reset-confirm"
              data-testid="reset-input-confirm"
              type="password"
              required
              minLength={6}
              value={pwd.confirm}
              onChange={(e) => setPwd((p) => ({ ...p, confirm: e.target.value }))}
              className={inputCls}
            />
          </div>
          <button
            type="submit"
            data-testid="reset-submit"
            disabled={busy || !token}
            className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-accent px-8 py-4 font-mono text-sm font-bold uppercase tracking-[0.15em] text-white shadow-[0_0_28px_rgba(255,0,122,0.4)] transition-all duration-300 hover:bg-accent-hover disabled:cursor-not-allowed disabled:opacity-60"
          >
            {busy ? <Loader2 size={18} className="animate-spin" /> : <KeyRound size={18} />}
            Guardar contraseña
          </button>
          {!token && (
            <p className="text-center font-mono text-[11px] uppercase tracking-[0.15em] text-zinc-500">
              Enlace no válido. Solicita uno nuevo desde el acceso.
            </p>
          )}
        </form>
      </div>
    </div>
  );
}
